import { defineMessages } from 'react-intl';

export default defineMessages({
  noClaims: {
    id: 'src.pages.Dashboard.noClaims',
    defaultMessage: "Looks like you don't have any claims!",
  },

  // CLAIM CARD TITLES
  vehicle: {
    id: 'src.pages.Dashboard.vehicle',
    defaultMessage: 'Vehicle',
  },
  property: {
    id: 'src.pages.Dashboard.property',
    defaultMessage: 'Property',
  },
  claimType: {
    id: 'src.pages.Dashboard.claimType',
    defaultMessage: 'Claim type',
  },
  incidentDate: {
    id: 'src.pages.Dashboard.incidentDate',
    defaultMessage: 'Incident date',
  },

  // CLAIM CARD VALUES
  claimNumberText: {
    id: 'src.pages.Dashboard.claimNumber',
    defaultMessage: 'Claim #{gwClaimNumber}',
  },
  claimNumberNoText: {
    id: 'src.pages.Dashboard.claimNumber',
    defaultMessage: '{claimId}',
  },
  claimNumberGW: {
    id: 'src.pages.Dashboard.claimNumber',
    defaultMessage: 'Reference #{claimNumberGW}',
  },
  vehicleModel: {
    id: 'src.pages.Dashboard.vehicleModel',
    defaultMessage: '{vehicleModel}',
  },
  propertyAddress: {
    id: 'src.pages.Dashboard.propertyAddress',
    defaultMessage: '{propertyAddress}',
  },
  claimTypeDescriptionLossScenario1: {
    id: 'src.pages.Dashboard.lossScenario1',
    defaultMessage: '{lossScenario1}',
  },
  claimTypeDescriptionLossScenario2: {
    id: 'src.pages.Dashboard.lossScenario2',
    defaultMessage: '{lossScenario2}',
  },
  dateOfIncident: {
    id: 'src.pages.Dashboard.dateOfIncident',
    defaultMessage: '{formattedDate}',
  },
  gwClaimStatus: {
    id: 'src.pages.Dashboard.gwClaimStatus',
    defaultMessage: '  {gwClaimStatus}',
  },
  adjusterDetails: {
    id: 'src.pages.Dashboard.adjusterDetails',
    defaultMessage: 'Adjuster Details',
  },
});
